import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.19 12.476h14.233L35.83 19.07a1.048 1.048 0 0 0 1.482 1.481l8.364-8.364a1.045 1.045 0 0 0-.003-1.517l-8.361-8.362a1.048 1.048 0 1 0-1.482 1.481l6.593 6.593H28.19a1.048 1.048 0 1 0 0 2.095ZM27.402 45.9c2.832.322 5.532-.143 7.801-1.38.98-.535 1.886-1.23 2.757-2.108 1.213-1.221 1.857-1.947 2.53-2.868l.082-.096c.841-.972 1.169-1.594 1.235-2.543.107-1.486-.552-2.625-2.1-4.062-.914-.847-1.997-1.563-3.32-2.211a59.226 59.226 0 0 0-.786-.383c-.966-.46-1.704-.736-2.451-.901-1.483-.33-2.805-.138-3.907.646-.435.309-.75.615-1.3 1.242l-.124.14a9.69 9.69 0 0 1-.303.334c-.61.638-1.186 1.093-1.772 1.406-2.89 1.54-6.937.907-9.44-1.479-1.405-1.476-2.266-3.692-2.216-5.778.04-1.698.603-3.352 1.576-4.644.268-.356.528-.643 1.24-1.369.219-.222.22-.223.364-.373.934-.972 1.398-2.059 1.389-3.336-.008-1.084-.237-1.897-.933-3.497l-.07-.16-.066-.155c-.603-1.399-1.1-2.32-1.729-3.172-.972-1.317-1.957-2.195-3.09-2.667-.807-.335-1.665-.391-2.469-.14-.634.2-1.04.463-1.787 1.114-.138.12-.138.12-.212.181-2.686 2.057-4.28 3.84-5.244 6.014-1.582 3.566-1.36 7.805.488 12.378 1.578 3.905 4.206 7.671 7.57 10.903 1.79 1.87 3.93 3.622 6.247 5.111 3.357 2.159 6.75 3.48 10.04 3.853Z",
    fill: "currentColor"
  }));
};

var SvgTransferred = styled(SvgComponent).withConfig({
  displayName: "Transferred__SvgTransferred",
  componentId: "sc-q91cql-0"
})(["", " ", ""], size, color);
export default SvgTransferred;